import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import { ThemeWrapper, useThemeStore } from "../shared/theme";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Notification } from "@src/shared/components/Notification";

const queryClient = new QueryClient();

export function App() {
  const { isDarkMode } = useThemeStore();

  return (
    <ThemeWrapper isDarkMode={isDarkMode}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Notification />
      </QueryClientProvider>
    </ThemeWrapper>
  );
}
